module.exports = __webpack_public_path__ + "static/media/Andrew de Leon.a25e9f49.png";